module.exports = __webpack_public_path__ + "b35e1ac7d4ffa572a987311815769ffc.fbx";